// extracted by mini-css-extract-plugin
export default {"plan-perks":"plan-list_plan-perks__eRHkm","plan-perks__list":"plan-list_plan-perks__list__V85G0","plan-perks__item":"plan-list_plan-perks__item__zS4UX"};